<!-- src/components/Footer.vue -->
<template>
    <v-container>
       <v-col class="text-right"> &copy; {{ currentYear }} Version: 1.1.2 | Date Built: 2026.01.17 </v-col>
    </v-container>
</template>

<script>
    export default {
        name: 'Footer',
        computed: {
            currentYear() {
                return new Date().getFullYear()
            }
        }
    }
</script>